import React, { useState, useMemo, useEffect, forwardRef, useImperativeHandle, useRef } from 'react'
import { cloneDeep } from 'lodash-es'
import Icon from '../icon'
import util from '../../utils/util'
import Button from '../../baseComponent/button'
import Checkbox from '../../baseComponent/checkbox'
import createInspiration from '../useFunModal/createInspiration'
import createOrEditChild from '../useFunModal/createOrEditChidInspiration'
import versionNumber from '../useFunModal/versionNumber'
import useVersionNumber from '../../common/hooks/useVersionNumber'
import TreeHomePage from './treeHomePage'
import TreeNextPage from './treeNextPage'
import { InspirationTreeList } from './context'
import './index.less'

const tabDefault = {
  label: '全部灵感集',
  value: null,
  type: 'tab',
}

export default forwardRef(({
  type,
  collectBtn = '采集',
  treeData,
  data,
  value,
  scrollHeight,
  listWidth = 640,
  onChange,
  onCreateInspiration,
  onDefaultCreateInspiration,
  onChooseTaskClose,
  onChooseTaskOk,
  onCancel,
  onOk,
  loading = false,
  tabOptionHead = tabDefault,
  renderTab,
  onCancelCollect,
  onItemCollect,
  collectBtnDisabled,
  singleCollection = false,
  hasMove = false, // 当hasMove为true则才会有hasReserveValue,onHasReserveChange
  hasCollectChange = true, // 控制item 点击采集是否需要改变数据
  hasReserveValue,
  onHasReserveChange,
  keyWords,
  onKeyWords,
  onLoad,
}, ref) => {
  const [nextStatus, setNextStatus] = useState(false)
  const [chidData, setChildData] = useState()
  const _tabOptionHead = cloneDeep(tabOptionHead)
  const pathArr = useRef([_tabOptionHead])
  const { isRealTimeAuthLimit } = useVersionNumber()

  const onClear = () => {
    if (pathArr.current.length > 1) { // 清空
      pathArr.current.length = 1
      setNextStatus(false)
    }
  }

  useImperativeHandle(ref, () => {
    return {
      onClear
    }
  })

  const onNext = (_, currentData, headPath, _keyWords) => {
    if (headPath) {
      pathArr.current[0].label = headPath
      pathArr.current[0].keyWords = _keyWords
    }
    pathArr.current.push(currentData)
    setChildData(currentData)
    setNextStatus(true)
  }

  const onGoBack = () => { // 返回上一步
    pathArr.current.pop()
    if (pathArr.current.length === 1) {
      setChildData(null)
      setNextStatus(false)
    } else {
      setChildData(pathArr.current[pathArr.current.length - 1])
    }
  }

  const onLink = (val) => { // 路径跳转
    if (val.value) {
      onGoBack()
    } else {
      pathArr.current.length = 1
      setChildData(null)
      setNextStatus(false)
    }
  }
  const contentValue = useMemo(() => {
    return {
      collectBtn,
      onCancelCollect,
      onItemCollect,
      singleCollection,
      hasMove,
      hasCollectChange,
    }
  }, [onCancelCollect, onItemCollect, singleCollection, hasMove, hasCollectChange])

  useEffect(() => { // 查找到当前层级下的最新数据 并更新
    if (nextStatus) {
      const lastNode = pathArr.current[pathArr.current.length - 1]
      const updateLastNode = treeData.findNodeByValue(lastNode.value)
      setChildData(updateLastNode.current)
      pathArr.current = pathArr.current.map((curItem) => {
        return treeData.findNodeByValue(curItem.value).current || curItem
      })
    }
  }, [data])

  return <InspirationTreeList.Provider value={contentValue}>
    <div style={{ position: 'relative', height: '100%' }}>
      <div className="tree-option">
        <div className="tree-option-content-wrap" style={{ width: listWidth * 2, transform: `translateX(${nextStatus ? -listWidth : 0}px)` }}>
          <TreeHomePage
            onLoad={onLoad}
            keyWords={keyWords}
            onKeyWords={onKeyWords}
            collectBtn={collectBtn}
            renderTab={renderTab}
            pathArr={pathArr.current}
            treeData={treeData}
            data={data}
            scrollHeight={scrollHeight}
            style={{ width: listWidth }}
            onNext={onNext}
            value={value}
            onChange={onChange}
            loading={loading}
          />
          <TreeNextPage
            pathArr={pathArr.current}
            data={chidData}
            scrollHeight={scrollHeight}
            style={{ width: listWidth }}
            onGoBack={onGoBack}
            onLink={onLink}
            onNext={onNext}
            value={value}
            loading={loading}
            onChange={onChange}
          />
        </div>
        <div className="tree-option-create-idea-mass">
          <div
            className="tree-option-create-idea-mass-wrap"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div
              className="tree-option-create-idea-mass-left"
              onClick={async (e) => {
                const isLimit = await isRealTimeAuthLimit('meinian_inspiration_limit')
                if (!isLimit) {
                  versionNumber({
                    title: '灵感集'
                  })
                  return
                }
                e.stopPropagation()
                const flag = onDefaultCreateInspiration?.()
                if (flag) {
                  return
                }
                if (nextStatus) {
                  createOrEditChild({
                    parentId: pathArr.current[pathArr.current.length - 1].type !== 'tab' ? pathArr.current[pathArr.current.length - 1].value : null,
                    onChange: (inspirationId, newItem) => {
                      onCreateInspiration?.(inspirationId, newItem.name, newItem)
                    },
                  })
                } else {
                  createInspiration({
                    onChooseTaskClose,
                    onChooseTaskOk,
                    disabledTask: true, // 采集创建没有选款任务
                    parentId: pathArr.current[pathArr.current.length - 1].type !== 'tab' ? pathArr.current[pathArr.current.length - 1].value : null,
                    onChange: (inspirationId, newItem) => {
                      util.track('mn-add-inspiration', {
                        module1: '采集时新建',
                      })
                      onCreateInspiration?.(inspirationId, newItem.name, newItem)
                    },
                  })
                }
              }}
            >
              <div className="tree-option-create-idea-mass-button">
                <Icon type="m-tianjia" />
              </div>
              创建{nextStatus && '子'}灵感集
            </div>
            {
            !singleCollection && <div>
              {type !== 'page' && <Button type="normal" style={{ marginRight: 8, width: 64, height: 32 }} onClick={onCancel}>取消</Button>}
              <Button
                disabled={collectBtnDisabled}
                type="primary"
                style={{ width: 64, height: 32 }}
                onClick={onOk}
              >确定</Button>
            </div>
          }
            {
              hasMove && <div className="tree-option-button-has-move">
                <Checkbox checked={hasReserveValue} onChange={(val) => onHasReserveChange(val)} /><span style={{ marginLeft: '8px' }}>保留原有款式</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </InspirationTreeList.Provider>
})
